import React from "react";

const STATUS_CONFIG = {
  success: {
    title: "Subscription active",
    message:
      "Payment is confirmed and your subscription is active. You can now continue to chat.",
    accent:
      "border-pl-success/20 bg-[rgba(45,106,79,0.08)] text-pl-success",
  },
  activating: {
    title: "Activating access",
    message:
      "Payment is confirmed. We are now syncing account access so you can enter chat.",
    accent:
      "border-pl-info/20 bg-[rgba(43,108,176,0.08)] text-pl-info",
  },
  pending: {
    title: "Subscription pending",
    message:
      "Your payment is being confirmed. Access will activate automatically once backend verification finishes.",
    accent:
      "border-pl-warning/20 bg-[rgba(188,108,37,0.08)] text-pl-warning",
  },
  failed: {
    title: "Subscription failed",
    message:
      "The payment attempt did not complete. Please retry the subscription checkout.",
    accent:
      "border-pl-error/20 bg-[rgba(155,34,38,0.08)] text-pl-error",
  },
  already_subscribed: {
    title: "Already subscribed",
    message:
      "This account already has an active subscription. You can proceed directly to chat.",
    accent:
      "border-pl-info/20 bg-[rgba(43,108,176,0.08)] text-pl-info",
  },
};

const ChatStatusBanner = ({ status }) => {
  const config = STATUS_CONFIG[status];

  if (!config) {
    return null;
  }

  return (
    <section
      aria-live="polite"
      className={`mb-8 rounded-10 border px-5 py-4 shadow-pl-sm ${config.accent}`}
    >
      <p className="text-12 font-semibold uppercase tracking-[0.18em]">
        Subscription Status
      </p>
      <h2 className="mt-2 text-18 font-semibold">{config.title}</h2>
      <p className="mt-2 text-14 leading-6 text-pl-text-secondary">
        {config.message}
      </p>
    </section>
  );
};

export default ChatStatusBanner;
